module.exports = __webpack_public_path__ + "img/text-indent-right.7c4fcc98.svg";